import { Typography } from '@trukt/ui/Typography';
import { LabelGroupProps } from './types';
import { Tooltip } from '@trukt/ui/Tooltip';

export const LabelGroup = ({
  value,
  subValue,
  valueProps,
  subValueProps,
  tooltipValue,
}: LabelGroupProps) => {
  return (
    <>
      <Typography className="overflow-ellipsis" {...valueProps}>
        <Tooltip title={tooltipValue ?? value}>{value}</Tooltip>
      </Typography>
      {subValue && (
        <Typography {...subValueProps} className="inline-block">
          {subValue}
        </Typography>
      )}
    </>
  );
};

export * from './types';
